import { render, staticRenderFns } from "./InputButton.vue?vue&type=template&id=dd65ec7a&scoped=true&"
import script from "./InputButton.vue?vue&type=script&lang=js&"
export * from "./InputButton.vue?vue&type=script&lang=js&"
import style0 from "./InputButton.vue?vue&type=style&index=0&id=dd65ec7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd65ec7a",
  null
  
)

export default component.exports